/* eslint-disable @typescript-eslint/no-explicit-any */
import { CHANNEL_SCALES, ALL_FIELD_TYPES } from '@carto/kepler.gl/constants'
import { getDatasetType, getSchemeFromTilesetDataset } from 'features/builder/state/builderSliceUtils'
import { KeplerTable, LayerTypes, TilingScheme } from 'features/builder/types'
import { MapType } from 'features/maps/types'
import IconHeatmap from 'assets/icons/layers/heatmap.svg?react'
import SpatialIndexLayer, { spatialIndexVisConfigs } from './SpatialIndexLayer'

const heatmapTileVisConfig = {
  ...spatialIndexVisConfigs,
  weightAggregation: 'weightAggregation'
}

export default class HeatmapTileLayer extends SpatialIndexLayer {
  constructor(props = {}) {
    super(props)
    this.registerVisConfig(heatmapTileVisConfig)
  }

  public get type() {
    return LayerTypes.HeatmapTile
  }

  get name() {
    return 'Heatmap'
  }

  get layerIcon() {
    return IconHeatmap
  }

  get visualChannels() {
    return {
      ...super.visualChannels,
      weight: {
        property: 'weight',
        field: 'weightField',
        scale: 'weightScale',
        domain: 'weightDomain',
        key: 'weight',
        defaultMeasure: 'property.density',
        supportedFieldTypes: [ALL_FIELD_TYPES.real, ALL_FIELD_TYPES.integer],
        channelScaleType: CHANNEL_SCALES.identity,
        accessor: 'getWeight',
        defaultValue: () => 1,
        nullValue: 1,
        aggregation: 'weightAggregation'
      }
    }
  }

  validateScale() {
    // Kepler is no ready to validate weight scale so we always return true
    return true
  }

  static findDefaultLayerProps(dataset: KeplerTable, foundLayers) {
    const emptyProps = { props: [] }

    if (foundLayers?.length) {
      return emptyProps
    }
    const scheme = getSchemeFromTilesetDataset(dataset)

    if (getDatasetType(dataset) === MapType.tileset && scheme === TilingScheme.Quadbin) {
      return {
        props: [
          {
            label: dataset.label,
            isVisible: true,
            columns: {}
          }
        ]
      }
    }
    return emptyProps
  }
}
